/**
 * Page Compositions for Weidner Apartment Homes Theme
 * 
 * Extends the base avenue theme pages with Weidner Apartment Homes customizations.
 * Merges base theme pages.json with company-level pages.json overrides.
 */

import basePagesData from '@vibesites/theme-avenue/pages.json';
import companyPagesData from './pages.json';
import { mergePages, resolvePageTokens } from '@vibesites/runtime';
import type { PageComposition } from '@vibesites/runtime';

const resolved = mergePages(basePagesData as any, companyPagesData as any);
export const pages: Record<string, PageComposition> = Object.fromEntries(
  resolved.map(p => [p.alias, resolvePageTokens(p)])
);

export default pages;
